/**
 * Resolve the client that owns corporate design placeholders for an edition.
 * Prefers mapper payload corporate_design (company account), then Mongo parent, then creator.
 *
 * @param {object|null|undefined} editionRV
 * @returns {object|null}
 */
export function getCorporateDesignClient(editionRV) {
  return editionRV?.creator?.corporate_design
    || editionRV?.creator?.parent
    || editionRV?.creator
    || null;
}

/**
 * @param {object|null|undefined} client
 * @param {'client_main_logo'|'client_main_logo_white'|'client_main_logo_multi_colored'} logoKey
 * @returns {string}
 */
export function getCorporateDesignLogoUrl(client, logoKey) {
  return client?.[logoKey]?.variations?.[0]?.file?.web_link || '';
}
